import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { ReportService } from "../report.service";
import { AcademyService } from "../report-services/academy.service";
import { DistrictSchoolService } from "../report-services/district-school.service";
import { GradeLevelService } from "../report-services/grade-level.service";
import { GroupService } from "../report-services/group.service";
import { HomeroomService } from "../report-services/homeroom.service";
import { InstructorService } from "../report-services/instructor.service";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import * as moment from "moment";

@Component({
	selector: "app-instructor-pbis",
	templateUrl: "./instructor-pbis.component.html",
	styleUrls: ["./instructor-pbis.component.css"],
})
export class InstructorPBISComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private reportService: ReportService,
		//Insert Custom Services Here
		private groupService: GroupService,
		private homeroomService: HomeroomService,
		private academyService: AcademyService,
		private gradelevelService: GradeLevelService,
		private instructorService: InstructorService,
		private schoolService: DistrictSchoolService,
		private dialogService: DialogService
	) {}

	report = {
		//Insert Custom Parameters Here
		SchoolID: 0,
		InstructorID: 0,
		AcademyID: 0,
		GradeLevelID: 0,
		HomeroomID: 0,
		GroupID: 0,
		STARTDATE: new Date(),
		ENDDATE: new Date(),
		PointsCategoryTypeID: 0,
		PointsCategoryID: 0,
		PointsItemID: 0,
		GroupPeriodsID: "Yes",
		PageByID: "Yes",
		ShowStudentNameID: "Yes",
		ImageLogo: "",
	};

	SchoolSelectShowAllID: any = 0;
	SchoolSelectShowAllText: any = "All Schools";

	LoadingInstructor: any = false;
	LoadingGradeLevel: any = false;
	LoadingAcademy: any = false;
	LoadingHomeroom: any = false;
	LoadingSchoolGroup: any = false;
	LoadingLogo: any = false;
	LoadingPointsCategoryType: any = false;
	LoadingPointsCategory: any = false;
	LoadingPointsItem: any = false;

	//Insert Custom Lists Here
	InstructorList: any = [];
	schoolList: any = [];
	GradeLevelList: any = [];
	AcademyList: any = [];
	HomeroomList: any = [];
	GroupList: any = [];
	PointsCategoryTypeList: any = [];
	PointsCategoryList: any = [];
	PointsItemList: any = [];
	ImageLogoList: any = [];

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	GroupPeriodsList = [
		//Insert Custom List Items Here
		{
			GroupPeriodsID: "Yes",
			GroupPeriodsName: "Yes",
		},
		{
			GroupPeriodsID: "No",
			GroupPeriodsName: "No",
		},
	];

	PageByList = [
		//Insert Custom List Items Here
		{
			PageByID: "Yes",
			PageByName: "Yes",
		},
		{
			PageByID: "No",
			PageByName: "No",
		},
	];

	ShowStudentNameList = [
		//Insert Custom List Items Here
		{
			ShowStudentNameID: "Yes",
			ShowStudentNameName: "Yes",
		},
		{
			ShowStudentNameID: "No",
			ShowStudentNameName: "No",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 440;

	subscription: any;

	ngOnInit() {
		//Insert Custom Init Methods Here
		// this.loadSchoolist()
		//this.loadInstructorList()
		// this.loadGradeLevelList()
		// this.loadAcademyList()
		// this.loadHomeroomList()
		// this.loadSchoolGroupList()

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.loadInstructorList();
		this.loadGradeLevelList();
		this.loadAcademyList();
		this.loadHomeroomList();
		this.loadSchoolGroupList();
		this.loadLogolist();
		this.loadPointsCategoryType();
	}

	onPointCategoryTypeChange(val) {
		this.report.PointsCategoryTypeID = val;

		this.loadPointsCategory();
	}

	onPointCategoryChange(val) {
		this.report.PointsCategoryID = val;

		this.loadPointsItem();
	}

	private loadSchoolist() {
		var result = this.schoolService.loadDistrictSchoolList("", 0);
		result.subscribe(
			(response) => {
				this.schoolList = response;

				if (this.schoolList.length > 1) {
					this.schoolList.unshift({
						SchoolID: 0,
						SchoolName: "All Schools",
					});
				} else {
					this.onSchoolChange(this.schoolList[0].SchoolID);
				}
			},
			(error) => {}
		);
	}

	private loadInstructorList() {
		this.LoadingInstructor = true;

		this.report.InstructorID = 0;
		var result = this.instructorService.loadInstructorList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.InstructorList = response;

				this.InstructorList.unshift({
					Teacher_PersonID: 0,
					Instructor: "All Instructors",
				});
				this.report.InstructorID = this.InstructorList[0].Teacher_PersonID;

				this.LoadingInstructor = false;
			},
			(error) => {
				this.LoadingInstructor = false;
			}
		);
	}

	private loadGradeLevelList() {
		this.LoadingGradeLevel = true;

		this.report.GradeLevelID = 0;
		var result = this.gradelevelService.loadGradeLevelList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.GradeLevelList = response;

				if (this.GradeLevelList.length > 1) {
					// this.GradeLevelList.unshift({
					//     GradeLevelID: 0,
					//     GradeLevelDesc: "All GradeLevels"
					// })
					this.report.GradeLevelID = this.GradeLevelList[0].GradeLevelID;
				} else {
					this.report.GradeLevelID = this.GradeLevelList[0].GradeLevelID;
				}

				this.LoadingGradeLevel = false;
			},
			(error) => {
				this.LoadingGradeLevel = false;
			}
		);
	}

	private loadAcademyList() {
		this.LoadingAcademy = true;

		this.report.AcademyID = 0;
		var result = this.academyService.loadAcademyList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.AcademyList = response;

				if (this.AcademyList.length > 1) {
					// this.AcademyList.unshift({
					//     AcademyId: 0,
					//     AcademyDesc: "All Academys"
					// })
					this.report.AcademyID = this.AcademyList[0].AcademyId;
				} else {
					this.report.AcademyID = this.AcademyList[0].AcademyId;
				}

				this.LoadingAcademy = false;
			},
			(error) => {
				this.LoadingAcademy = false;
			}
		);
	}

	private loadHomeroomList() {
		this.LoadingHomeroom = true;

		this.report.HomeroomID = 0;
		var result = this.homeroomService.loadHomeroomList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.HomeroomList = response;

				if (this.HomeroomList.length > 1) {
					this.HomeroomList.unshift({
						HomeroomId: 0,
						HomeRoom: "All Homerooms",
					});

					this.report.HomeroomID = this.HomeroomList[0].HomeroomId;
				} else {
					this.report.HomeroomID = this.HomeroomList[0].HomeroomId;
				}

				this.LoadingHomeroom = false;
			},
			(error) => {
				this.LoadingHomeroom = false;
			}
		);
	}

	private loadSchoolGroupList() {
		this.LoadingSchoolGroup = true;

		this.report.GroupID = 0;
		var result = this.groupService.loadGroupList(0, this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.GroupList = response;

				this.report.GroupID = this.GroupList[0].GroupID;

				this.LoadingSchoolGroup = false;
			},
			(error) => {
				this.LoadingSchoolGroup = false;
			}
		);
	}

	private loadLogolist() {
		this.LoadingLogo = true;

		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;

				this.LoadingLogo = false;
			},
			(error) => {
				this.LoadingLogo = false;
			}
		);
	}

	private loadPointsCategoryType() {
		this.LoadingPointsCategoryType = true;

		var result = this.reportService.PointsCategoryTypeGetList();
		result.subscribe(
			(response) => {
				this.PointsCategoryTypeList = response;

				this.PointsCategoryTypeList.unshift({
					PointsCategoryTypeID: 0,
					PointsCategoryTypeDesc: "All",
				});

				this.report.PointsCategoryTypeID = this.PointsCategoryTypeList[0].PointsCategoryTypeID;

				this.LoadingPointsCategoryType = false;

				this.loadPointsCategory();
			},
			(error) => {
				this.LoadingPointsCategoryType = false;
				this.LoadingPointsCategory = false;
				this.LoadingPointsItem = false;
			}
		);
	}

	private loadPointsCategory() {
		this.LoadingPointsCategory = true;

		var result = this.reportService.PointsCategoryGetList(this.report.PointsCategoryTypeID);
		result.subscribe(
			(response) => {
				this.PointsCategoryList = response;

				this.PointsCategoryList.unshift({
					PointsCategoryID: 0,
					PointsCategoryDesc: "All",
				});

				this.report.PointsCategoryID = this.PointsCategoryList[0].PointsCategoryID;

				this.LoadingPointsCategory = false;

				this.loadPointsItem();
			},
			(error) => {
				this.LoadingPointsCategory = false;
				this.LoadingPointsItem = false;
			}
		);
	}

	private loadPointsItem() {
		this.LoadingPointsItem = true;

		var result = this.reportService.PointsItemGetList(this.report.PointsCategoryTypeID, this.report.PointsCategoryID);
		result.subscribe(
			(response) => {
				this.PointsItemList = response;

				this.PointsItemList.unshift({
					PointsItemID: 0,
					PointsItemDesc: "All",
				});

				this.report.PointsItemID = this.PointsItemList[0].PointsItemID;

				this.LoadingPointsItem = false;
			},
			(error) => {
				this.LoadingPointsItem = false;
			}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		//Insert Custom Error Checks Here
		// if (!this.report.SchoolID) {
		//   this.errorMessage = "Select the School"
		//   return;
		// }

		// if (!this.report.InstructorPersonID) {
		// 	this.errorMessage = "Select the InstructorPerson"
		// 	return;
		// }

		// if (!this.report.GradeLevelID) {
		// 	this.errorMessage = "Select the GradeLevel"
		// 	return;
		// }

		// if (!this.report.ACADEMYID) {
		// 	this.errorMessage = "Select the ACADEMY"
		// 	return;
		// }

		// if (!this.report.HOMEROOMID) {
		// 	this.errorMessage = "Select the HOMEROOM"
		// 	return;
		// }

		// if (!this.report.GROUPID) {
		// 	this.errorMessage = "Select the GROUP"
		// 	return;
		// }

		// if (!this.report.STARTDATE) {
		// 	this.errorMessage = "Select the STARTDATE"
		// 	return;
		// }

		// if (!this.report.ENDDATE) {
		// 	this.errorMessage = "Select the ENDDATE"
		// 	return;
		// }

		// if (!this.report.MeritTypeID) {
		// 	this.errorMessage = "Select the MeritType"
		// 	return;
		// }

		// if (!this.report.GroupPeriodsID) {
		// 	this.errorMessage = "Select the GroupPeriods"
		// 	return;
		// }

		// if (!this.report.PageByID) {
		// 	this.errorMessage = "Select the PageBy"
		// 	return;
		// }

		// if (!this.report.ShowStudentNameID) {
		// 	this.errorMessage = "Select the ShowStudentName"
		// 	return;
		// }

		var strParam = this.GetStrParam();
		this.isProcessing = true;

		var reportID = 440;

		var result = this.reportService.Print(reportID, strParam, this.report.SchoolID, this.OutputTypeID);

		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		//Parameter 1: SchoolID
		strParam += this.report.SchoolID + "|SchoolID";

		//Parameter 2: InstructorPersonID
		strParam += "," + this.report.InstructorID + "|InstructorPersonID";

		//Parameter 3: GradeLevelID
		strParam += "," + this.report.GradeLevelID + "|GradeLevelID";

		//Parameter 4: ACADEMYID
		strParam += "," + this.report.AcademyID + "|ACADEMYID";

		//Parameter 5: HOMEROOMID
		strParam += "," + this.report.HomeroomID + "|HOMEROOMID";

		//Parameter 6: GROUPID
		strParam += "," + this.report.GroupID + "|GROUPID";

		//Parameter 7: STARTDATE
		strParam += "," + moment(this.report.STARTDATE).format("MM/DD/YYYY") + "|STARTDATE";

		//Parameter 8: ENDDATE
		strParam += "," + moment(this.report.ENDDATE).format("MM/DD/YYYY") + "|ENDDATE";

		//Parameter 9: PointsCategoryTypeID
		strParam += "," + this.report.PointsCategoryTypeID + "|PointsCategoryTypeID";

		//Parameter 10: PointsCategoryID
		strParam += "," + this.report.PointsCategoryID + "|PointsCategoryID";

		//Parameter 11: PointsItemID
		strParam += "," + this.report.PointsItemID + "|PointsItemID";

		//Parameter 12: GroupPeriods
		strParam += "," + this.report.GroupPeriodsID + "|GroupPeriods";

		//Parameter 13: PageBy
		strParam += "," + this.report.PageByID + "|PageBy";

		//Parameter 14: ShowStudentName
		strParam += "," + this.report.ShowStudentNameID + "|ShowStudentName";

		//Parameter 15: ImageLogo
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}

	IsLoading() {
		return (
			this.LoadingInstructor == true ||
			this.LoadingGradeLevel == true ||
			this.LoadingAcademy == true ||
			this.LoadingHomeroom == true ||
			this.LoadingSchoolGroup == true ||
			this.LoadingLogo == true ||
			this.LoadingPointsCategoryType == true ||
			this.LoadingPointsCategory == true ||
			this.LoadingPointsItem == true
		);
	}
}
